<div class="container my-4 contactContent" id="">
  <h3 class="page-title">Inquiries about Website Support</h3>

  <p style="font-style: italic">
    <strong>{{ "ContactAssessor.Number" | translate }} </strong>
  </p>

  <hr />
  <form [formGroup]="contactForm" (ngSubmit)="submit()">
    <p class="form-label">
      {{ "ContactAssessor.Name" | translate }} <span class="color-red">*</span>
    </p>
    <div
      class="form-row"
      style="
        display: flex;
        align-items: flex-start;
        flex-wrap: nowrap;
        gap: 10px;
        margin-bottom: 20px;
      "
      >
      <div
        class="form-group col-md-6"
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 49%;
        "
        >
        <input
          type="text"
          formControlName="firstName"
          class="form-control"
          id="inputFirst-General"
          placeholder="{{ 'ContactAssessor.FirstName' | translate }}"
          />
          <div class="invalid-feedback" style="display: block">
            @if (hasError('firstName', 'required')) {
              {{
              "ContactAssessor.Required" | translate
              }}
            }
          </div>
        </div>
        <div class="form-group col-md-6">
          <input
            type="text"
            formControlName="lastName"
            class="form-control"
            id="inputLast-General"
            placeholder="{{ 'ContactAssessor.LastName' | translate }}"
            />
            <div class="invalid-feedback" style="display: block">
              @if (hasError('lastName', 'required')) {
                {{
                "ContactAssessor.Required" | translate
                }}
              }
            </div>
          </div>
        </div>
        <div class="form-group" style="margin-bottom: 20px">
          <p class="form-label">
            {{ "ContactAssessor.Email" | translate }}
            <span class="color-red">*</span>
          </p>
          <input
            type="email"
            class="form-control"
            formControlName="email"
            placeholder="{{ 'ContactAssessor.Email' | translate }}"
            />
            <div class="invalid-feedback" style="display: block">
              @if (hasError('email', 'required')) {
                {{ "ContactAssessor.Required" | translate }}
              }
            </div>
          </div>
          <p class="form-label">
            {{ "ContactAssessor.Phone" | translate }} <span class="color-red">*</span>
          </p>
          <div class="form-row">
            <div class="form-group col-12" style="margin-bottom: 20px">
              <input
                class="form-control"
                type="text"
                appPhoneMask
                placeholder="{{ 'ContactAssessor.Phone' | translate }}"
                formControlName="phone"
                id="inputPhone-General"
                />
                <div class="invalid-feedback" style="display: block">
                  @if (hasError('phone', 'required')) {
                    {{
                    "ContactAssessor.Required" | translate
                    }}
                  }
                </div>
              </div>
            </div>

            <div formArrayName="ains">
              @for (ainCtrl of ains.controls; track ainCtrl; let i = $index) {
                <div
                  class="form-group"
                  >
                  <p class="form-label">
                    <!-- AIN {{ i + 1 }} ({{ 'ContactAssessor.Ain' | translate}}) -->
                    AIN ({{ "ContactAssessor.Ain" | translate }})
                  </p>
                  <!-- [(ngModel)]="value"] -->
                  <input
                    type="text"
                    class="form-control"
                    appAinMask
                    [formControlName]="i"
                    placeholder="XXXX-XXX-XXX"
                    />
                    <!-- Remove button (only show if more than 1 AIN) -->
                    @if (ains.length > 1) {
                      <button
                        type="button"
                        class="btn btn-secondary mt-1"
                        (click)="removeAin(i)"
                        >
                        - Remove
                      </button>
                    }
                  </div>
                }
                <!-- Add another AIN button -->
                <!-- [disabled]="!value?.trim()" disable add button -->
                <button type="button" class="btn btn-secondary mt-2" (click)="addAin()">
                  + Add another AIN
                </button>
              </div>

              <!-- <p class="form-label"  style="margin-top: 20px;" >{{'ContactAssessor.Address'| translate}} <span class="color-red">*</span></p>
              <app-certificate-address
                [parentFormGroup]="contactForm"
                streetNumber="number"
                streetDirection="direction"
                streetName="street"
                streetType="type"
                unitNumber="unit"
                city="city"
                zipCode="zipCode"

                >
              </app-certificate-address> -->

              <p class="form-label" style="margin-top: 20px">
                TOPIC OF REQUEST<span class="color-red">*</span>
              </p>
              <div class="form-group">
                <select formControlName="topic" class="form-select">
                  <option selected value="">Select..</option>
                  <option>Unable to login</option>
                  <option>e-Services</option>
                  <option>No Situs Address Available for e-Notification</option>
                  <option>Incorrect Parcel Information</option>
                  <option>
                    Business Personal Property Statement 571-L/ Pin Reset/ Invalid Pin
                  </option>
                  <option>Others</option>
                </select>
                <div class="invalid-feedback" style="display: block">
                  @if (hasError('topic', 'required')) {
                    {{ "ContactAssessor.Required" | translate }}
                  }
                </div>
              </div>

              @if (contactForm.get('topic')?.value === 'e-Services') {
                <div>
                  <p class="form-label" style="margin-top: 20px">
                    PLEASE SELECT ALL THAT APPLY<span class="color-red">*</span>
                  </p>
                  <div
                    class="form-group d-flex align-items-center gap-3"
                    formArrayName="eserviceChoices"
                    >
                    @for (option of eserviceOptions; track option; let i = $index) {
                      <div
                        class="form-check"
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [formControlName]="i"
                          [id]="option.id"
                          (change)="onCheckboxChange(i)"
                          />
                          <label class="form-check-label" [for]="option.id">
                            {{ option.label }}
                          </label>
                        </div>
                      }
                    </div>
                  </div>
                }

                <p class="form-label" style="margin-top: 20px">
                  {{ "ContactAssessor.Description" | translate }}
                </p>
                <div class="form-group">
                  <textarea
                    class="form-control"
                    formControlName="description"
                    id="inputDescription-General"
                    rows="4"
                    placeholder="Type here"
                  ></textarea>
                </div>
                <p class="form-label" style="margin-top: 20px">
                  PLEASE INCLUDE A SCREENSHOT OF THE ISSUE OR ERROR MESSAGE (FILE FORMATS
                  ACCEPTED: PDF, PNG, JPEG)
                </p>
                <div class="form-group">
                  <app-file-upload
                    formControlName="file"
                    [progress]="progress"
                  ></app-file-upload>
                  <div class="invalid-feedback" style="display: block">
                    @if (hasError('file', 'required')) {
                      {{ "ContactAssessor.Required" | translate }}
                    }
                    @if (hasError('file', 'requiredFileType')) {
                      Only PDF, Docx, PNG, JPEG
                    }
                    @if (hasError('file', 'requiredFileSize')) {
                      Size to exceeds 10 MB
                    }
                  </div>
                </div>

                <div class="form-group" style="margin-top: 15px">
                  <app-captcha [form]="contactForm" captchaFieldName="recaptchaReactive"></app-captcha>
                  <div class="invalid-feedback" style="display: block">
                    @if (hasError('recaptchaReactive', 'required')) {
                      {{
                      "ContactAssessor.Required" | translate
                      }}
                    }
                  </div>
                </div>

                <button type="submit" class="btn btn-primary mr-4" style="margin-top: 15px">
                  Submit</button
                  >@if (success) {
                  <span>Successfully Submitted</span>
                }
              </form>
            </div>
